import BeforeAfterBetweenLetters from "../../components/Nursery/English/BeforeAfterBetweenLetters";
import CircleCorrectLetter from "../../components/Nursery/English/CircleCorrectLetter";
import MatchObjectsToLetter from "../../components/Nursery/English/LetterObject";
import MatchLetters from "../../components/Nursery/English/MatchLetters";
import MatchObjectWithLetters from "../../components/Nursery/English/MatchObjectWithLetters";
import LetterObjectMatch from "../../components/Nursery/English/ObjectLetter";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/nursery/english-language/match-letter", title: "Match Letters", component: MatchLetters},
    { url: "/nursery/english-language/match-object-with-letter", title: "Match Object With Letter", component: MatchObjectWithLetters},
    { url: "/nursery/english-language/object-from-letter", title: "Find Object from Letter", component: LetterObjectMatch},
    { url: "/nursery/english-language/letter-from-object", title: "Find Letter from Object", component: MatchObjectsToLetter},
    { url: "/nursery/english-language/before-after-between-letters", title: "Before / After / Between Letters", component: BeforeAfterBetweenLetters},
    { url: "/nursery/english-language/circle-correct-letter", title: "Circle Correct Letter", component: CircleCorrectLetter},
];


export default topics;